import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import {TITLE_ICONS} from "../../utils/constants";
import './styles.scss';
import {FC} from "react";

const statusesWithIcon = ['locked', 'completed', 'inProgress', 'failed', 'optInRequired', 'selectSportTeamToStart', 'expired'];

interface MissionStatusPrizeProps {
    isFreeSpin: boolean
    gameBoxType: string
    type: string
    prizeType: string
}

const MissionStatusPrize:FC<MissionStatusPrizeProps> = ({isFreeSpin, gameBoxType, type, prizeType}) => {
    const { t } = useTranslation();

    const drawMissionIconPrize = () => {
        switch (prizeType) {
            case 'tourTicket':
                return <img src={`/static/images/${TITLE_ICONS[gameBoxType]}/gos.png`} width={58} alt="gos" />;
            case 'freespins':
                return <img src={`/static/images/${TITLE_ICONS[gameBoxType]}/spin.png`} width={70} alt="spin" />;
            case 'wheelOfFortune':
                return <img src={`/static/images/${TITLE_ICONS[gameBoxType]}/wheel.png`} width={32} alt="wheel" />;
            default:
                return '';
        }
    };

    const statusIcons = {
        inProgress: '/static/images/unlocked.png',
        locked: '/static/images/locked.png',
        selectSportTeamToStart: '/static/images/locked.png',
        expired: '/static/images/locked.png',
    };

    return (
        <>
      <span className={`mission__status mission__status--${type}`}>
        {statusesWithIcon.includes(type) ? <p>{t(type)}</p> : null}
          <span className={cn('lock-icon')}>
          {statusIcons[type]  && <img src={statusIcons[type]} width={14} alt={type} />}
        </span>
      </span>

            {!isFreeSpin && drawMissionIconPrize() && (
                <div className={'status-icon'}>
                    <p className={'mission-icon'}>{drawMissionIconPrize()}</p>
                </div>
            )}
        </>
    );
};

export default MissionStatusPrize;
